<h1 mat-dialog-title>{{ !data?.id ? ("add_user" | transloco) : ("edit_user" | transloco) }}</h1>
<mat-divider></mat-divider>
<mat-dialog-content>
    <form [formGroup]="formGroup" autocomplete="off" novalidate>
        <input autocomplete="false" name="hidden" type="text" style="display: none" />
        <p>
            <mat-form-field>
                <mat-label>{{ "email" | transloco }}</mat-label>
                <input matInput formControlName="email" autocomplete="off" />
                @if (formGroup.get("email")?.hasError("required")) {
                    <mat-error>{{ "email_nessesary" | transloco }}</mat-error>
                }
                @if (formGroup.get("email")?.hasError("email")) {
                    <mat-error>{{ "email_invalid" | transloco }}</mat-error>
                }
            </mat-form-field>
        </p>

        <p>
            <mat-form-field>
                <mat-label>{{ "password" | transloco }}</mat-label>

                <input matInput type="{{ showPassword ? 'text' : 'password' }}" formControlName="password" autocomplete="new-password" />
                <button
                    mat-icon-button
                    matSuffix
                    (click)="showPassword = !showPassword"
                    [attr.aria-label]="'Hide password'"
                    [title]="showPassword ? ('hide_password' | transloco) : ('show_password' | transloco)"
                >
                    <mat-icon matButtonIcon>{{ showPassword ? "visibility" : "visibility_off" }}</mat-icon>
                </button>
                <button
                    mat-icon-button
                    matSuffix
                    (click)="generatePassword()"
                    [attr.aria-label]="'generate_password' | transloco"
                    title="('generate_password' | transloco)"
                >
                    <mat-icon matButtonIcon>lock_reset</mat-icon>
                </button>
                @if (formGroup.get("password")?.hasError("required")) {
                    <mat-error>{{ "password_nessesary" | transloco }}</mat-error>
                }
            </mat-form-field>
        </p>
        <p>
            <pixl-password-strength
                [passwordToCheck]="formGroup.value.password!"
                (passwordStrength)="onPasswordStrengthChanged($event)"
            ></pixl-password-strength>
        </p>

        @if (subjects$ | async; as sj) {
            <mat-form-field>
                {{ "subjects_professions" | transloco }}
                <mat-select formControlName="subjectsRel" multiple>
                    @for (subject of sj; track subject.id) {
                        <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        @if (consumers$ | async; as con) {
            <mat-form-field>
                {{ "consumers" | transloco }}
                <mat-select formControlName="consumers" multiple>
                    @for (consumer of con; track consumer.id) {
                        <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        <mat-button-toggle-group formControlName="role">
            @for (role of roles; track role) {
                <mat-button-toggle
                    [disabled]="isOwnAccount()"
                    [value]="role.valueOf()">
                    {{ getEditorRoleViewValue(role) }}
                </mat-button-toggle>
            }
        </mat-button-toggle-group>
        @if (formGroup.get("role")?.hasError("required")) {
            <mat-error>{{ "role_nessesary" | transloco }}</mat-error>
        }
    </form>
</mat-dialog-content>
<mat-divider style="margin-top: 30px"></mat-divider>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">{{ "cancel" | transloco }}</button>
    <button mat-raised-button color="primary" (click)="onSave()">{{ "save" | transloco }}</button>
</div>
